import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import CarouselData from "./CarouselData";

const CarouselContents = () => {
  const carousel = CarouselData();

  return (
    <Carousel
      showArrows={true}
      showIndicators={false}
      infiniteLoop={true}
      autoPlay={true}
      dynamicHeight={false}
      stopOnHover={true}
      emulateTouch={true}
      showStatus={false}
      useKeyboardArrows={true}
      showThumbs={false}
    >
      {carousel.map((item) => (
        <div
        key={item?.id}
        className="detail-container"
        >
          <div className="img-div">
            <img src={item?.imgSrc} alt={item?.caption} className="img" />
          </div>

          <div className="feedback-text-div ">
            <p className="feedback-text">{item?.description}</p>

            <span className="feedback-role">{item?.caption}</span>
          </div>
        </div>
      ))}
    </Carousel>
  );
};

export default CarouselContents;
